// Utility function to convert Dropbox share URLs to direct download URLs
// and resolve relative /api/media/... URLs against the backend.
// Falls back to window.location.origin when REACT_APP_BACKEND_URL is not baked
// into the production build.
const RUNTIME_ORIGIN = (() => {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (env && typeof env === "string" && env.startsWith("http")) return env.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location && window.location.origin) return window.location.origin;
  return "";
})();
const BACKEND_URL = RUNTIME_ORIGIN;

export const convertDropboxUrl = (url) => {
  if (!url) return url;
  
  // Resolve admin-uploaded media (relative path) to absolute backend URL
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Check if it's a Dropbox URL
  if (url.includes('dropbox.com')) {
    // Replace www.dropbox.com with dl.dropboxusercontent.com
    let convertedUrl = url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
    
    // Remove dl=0 parameter if present
    convertedUrl = convertedUrl.replace(/[&?]dl=0/, '');
    
    // If there's no raw=1, the dl.dropboxusercontent.com should work
    // But let's also handle the case where we need to add raw=1
    if (!convertedUrl.includes('raw=1') && !convertedUrl.includes('dl.dropboxusercontent.com')) {
      // For URLs that still have dropbox.com, add raw=1
      if (convertedUrl.includes('?')) {
        convertedUrl = convertedUrl + '&raw=1';
      } else {
        convertedUrl = convertedUrl + '?raw=1';
      }
    }
    
    return convertedUrl;
  }
  
  return url;
};

// Convert all Dropbox URLs in HTML content (for article body)
export const convertDropboxUrlsInHtml = (html) => {
  if (!html) return html;
  
  // Regex to find image src attributes with Dropbox URLs
  // This handles both regular img tags and those with classes
  const imgRegex = /(<img[^>]*?)src=["'](https?:\/\/[^"']*dropbox\.com[^"']*)["']([^>]*?>)/gi;
  
  let out = html.replace(imgRegex, (match, before, url, after) => {
    const convertedUrl = convertDropboxUrl(url);
    return `${before}src="${convertedUrl}"${after}`;
  });

  // Also resolve relative /api/media/ image sources to absolute URLs
  const apiMediaRegex = /(<img[^>]*?)src=["']\/api\/(media\/[^"']+)["']([^>]*?>)/gi;
  out = out.replace(apiMediaRegex, (match, before, path, after) => {
    return `${before}src="${BACKEND_URL}/api/${path}"${after}`;
  });

  return out;
};

export default { convertDropboxUrl, convertDropboxUrlsInHtml };
